const getResponsiveClassname = (className, isMobile, isTablet) => {
  if (isMobile) return `${className}-mobile`;
  if (isTablet) return `${className}-tablet`;
  return className;
};

export default getResponsiveClassname;
